import React from 'react'
// libs
import styled, { css } from 'styled-components'
// components
import { FloatingBottomPaper } from 'components/FormElements/FloatingActions/views'
import SidebarInfoForm from 'components/PageComponents/Plans/Edit/components/SidebarInfo/components/DetailsSection/components/Form'
import LinkedPlans from 'components/PageComponents/Plans/Edit/components/SidebarInfo/components/DetailsSection/components/LinkedPlans'
// context
import { PlanDetailsContext } from 'containers/Plan/Details/layers/API'
import { ReviewDrawerContext } from 'context/ReviewDrawerContext'
import { MainLayoutAPIContext } from 'containers/MainLayout/layers/API'
// hocs
import { withDropzone } from 'hocs/index'
// types
import { IPlan } from 'types/graphql'

// types
interface WrapperProps {
  $isDrawerExpanded: boolean
  $isReview: boolean
}

interface IIncomingProps {
  entity: IPlan
}

const Wrapper = styled('div')<WrapperProps>`
  margin: 0 16px;

  ${FloatingBottomPaper} {
    left: 72px;
    width: ${({ $isReview }) => ($isReview ? '600px' : '414px')};
    transition: 0.2s margin-left ease-in-out;

    ${({ $isDrawerExpanded }) =>
      $isDrawerExpanded &&
      css`
        margin-left: 168px;
      `}

    ${({ $isReview }) =>
      $isReview &&
      css`
        left: unset;
        right: 0;
      `}
  }
`

const DetailsSection: React.FC<IIncomingProps> = ({ entity }) => {
  const isReview = React.useContext(ReviewDrawerContext)

  const { initialValues, handleSubmit } = React.useContext(PlanDetailsContext)
  const { isDrawerExpanded } = React.useContext(MainLayoutAPIContext)

  return (
    <Wrapper $isReview={isReview} $isDrawerExpanded={isDrawerExpanded}>
      <SidebarInfoForm initialValues={initialValues} onSubmit={handleSubmit} plan={entity} />
      <LinkedPlans plan={entity} />
    </Wrapper>
  )
}

export default withDropzone(DetailsSection)
